import { render, staticRenderFns } from "./DetailTablePatientVisit.vue?vue&type=template&id=66f34f3e&scoped=true"
import script from "./DetailTablePatientVisit.vue?vue&type=script&lang=js"
export * from "./DetailTablePatientVisit.vue?vue&type=script&lang=js"
import style0 from "./DetailTablePatientVisit.vue?vue&type=style&index=0&id=66f34f3e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66f34f3e",
  null
  
)

export default component.exports